import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import HistorySection from 'Components/HistorySection';
import HistoryRowListing from 'Components/HistoryRowListing';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import HistoryRowControls from 'Components/HistoryRowControls';

const BNSQHistory = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'diagnosticSurvey.bnsq.title'} />}
      newButton={
        <DocumentCreationButton
          name="bnsq"
          text={'diagnosticSurvey.bnsq.newBNSQ'}
          onClick={startEdit({}, 'bnsq')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={<></>}
        contentFormat={() => <></>}
        makeDate
        makeControls
        historyRowControls={d => <HistoryRowControls document={d} startEdit={startEdit} view={view} />}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'bnsq'>[];
  startEdit: StartEdit<IDocumentWithTypeV2<'bnsq'>>;
  view?: IView;
}

export default BNSQHistory;
